const isEmailValid = (email: string) => /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(email);

export default isEmailValid;
